import { defineComponent } from '@vue/composition-api';
import { useTabsContext } from './SdsTabsContext.js';

var script = defineComponent({
    name: 'SdsTabBadge',
    props: {
        isNewBadge: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup: function () {
        var background = useTabsContext().background;
        return {
            background: background
        };
    }
});

export default script;
